// extracted by mini-css-extract-plugin
module.exports = {"sideCartContextProvider":"SideCartContextProvider_sideCartContextProvider__t3Wpz"};